// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import ExternalNotes from '@deere/cps-it.warranty-model-factory/lib/external-notes';
import {FormattedMessage} from 'react-intl';
import InstructionsList from '../../../part-requests/request-details/components/instructions-panels/instructions-list';

const InternalNotesPanel = props => {

    const title = (
        <span>
            <FormattedMessage id='INTERNAL_EQUIPMENT_NOTES'/>
        </span>
    );

    const body = (
        <div className='internal-notes'>
            <InstructionsList instructions={props.internalNotes.internalNotes}/>
        </div>
    );

    return (
        <Accordion
            accordionId='internal-notes-accordion'
            body={body}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={title}
        />
    );

};

InternalNotesPanel.displayName = 'InternalNotesPanel';
InternalNotesPanel.propTypes = {
    internalNotes: PropTypes.instanceOf(ExternalNotes).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default InternalNotesPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/internal-notes-panel.js